import React from 'react'

function InfoServices() {
  return (
    <div className="container py-4">

<h2 className="card-title">¿Qué servicios tiene IDECABA?</h2>
    
    <div className="mb-5"></div>

<div className="panel-horizontal-content bg-light rounded">
  <div className="panel-horizontal ">
  <div className="card-body">
  <h4 className="card-title">Servicio WMS</h4>
  <p className="card-text">
Permite la visualización de los datos geoespaciales, tanto vectoriales como raster, facilitando la
navegación interactiva en un mapa.</p>
</div>
  </div>
</div>

<div className="mb-5"></div>

<div className="panel-horizontal-content bg-light rounded" >
  <div className="panel-horizontal ">
  <div className="card-body">
  <h4 className="card-title">Servicio WFS</h4>
  <p className="card-text">
Permite la consulta de atributos y la descarga de los datos, facilitando el uso y explotación de
los datos para edición y guardado de versiones propias.</p>
</div>
  </div>
</div>
</div>

  )
}

export default InfoServices